const PROJECT_ID = '4509078345220096';

export {PROJECT_ID};
